<agpr-take-over-panel
    [id]="id"
    [headerIcon]="'fa-kit fa-agpr-insights'"
    [header]="'Briefings.blockType.autoGeninsights.label'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [minPanelWidth]="600"
    [maxPanelWidth]="400"
    [responsiveWidth]="true"
    [width]="25"
    class="agpr-curatedAutoInsightDialog-overlay"
    (visibleChange)="close()"
>

    <div class="agpr-curatedAutoInsightDialog">
        <agpr-scroll-panel>
             <h3 class="agpr-curatedAutoInsightDialog-heading">
                {{ 'Briefings.blockType.autoGeninsights.insightsFor' | localize}}
            </h3>

            <div class="agpr-curatedAutoInsightDialog-extraSpacing">
                <agpr-radio
                    [id]="id + '_curatedAutoInsightDialog_mentionsInSection'"
                    [label]="'Briefings.blockType.autoGeninsights.mentionsInSection' | localize: {title: blockTitle}"
                    [hiddenLabel]="'Briefings.blockType.autoGeninsights.mentionsInSection' | localize: {title: blockTitle}"
                    [(ngModel)]="saveAllMentions"
                    (ngModelChange)="handleNumberOfMentions()"
                    [value]="false"
                ></agpr-radio>
                <agpr-radio
                    [id]="id + '_curatedAutoInsightDialog_allSavedMentions'"
                    label="Briefings.blockType.autoGeninsights.allSavedMentions"
                    hiddenLabel="Briefings.blockType.autoGeninsights.allSavedMentions"
                    [(ngModel)]="saveAllMentions"
                    (ngModelChange)="handleNumberOfMentions()"
                    [value]="true"
                ></agpr-radio>
            </div>

            <div class="agpr-curatedAutoInsightDialog-spacing">
                <agpr-checkbox
                    [id]="id + '_curatedAutoInsightDialog_allSavedMentions'"
                    label="Briefings.blockType.autoGeninsights.withoutInsights"
                    [binary]="true"
                    [(ngModel)]="withoutInsightsOnly"
                    (ngModelChange)="handleNumberOfMentions()"
                ></agpr-checkbox>
            </div>

            <agpr-message
                [severity]="messageSeverityEnum.info"
            >
                <h4>{{ 'Briefings.blockType.autoGeninsights.insightsToBeGenerated.label' | localize: {count: numMentions } }}</h4>
                <span
                    [innerHTML]="'Briefings.blockType.autoGeninsights.insightsToBeGenerated.message' | localize"
                ></span>
            </agpr-message>

            @if (numMentions > 100) {
                <agpr-message
                    [severity]="messageSeverityEnum.warning"
                    [agprTooltip]="'Briefings.blockType.autoGeninsights.limitFeedback.tooltip'"
                >
                    {{ 'Briefings.blockType.autoGeninsights.limitFeedback' | localize }}
                </agpr-message>
            }

            <h3 class="agpr-curatedAutoInsightDialog-heading">
                {{ 'Briefings.blockType.autoGeninsights.settings' | localize}}
            </h3>
            <div class="agpr-curatedAutoInsightDialog-extraSpacing">
                <agpr-dropdown
                    label="Briefings.blockType.autoGeninsights.insightType"
                    [options]="mentionInsightTypesOptions"
                    [(ngModel)]="selectedMentionInsightType"
                    (ngModelChange)="updateGenerateButtonTooltip()"
                ></agpr-dropdown>
            </div>

            @if (selectedMentionInsightType?.value === mentionInsightTypes.CONTEXTUAL_ANALYSIS || selectedMentionInsightType?.value === mentionInsightTypes.SENTIMENT_OPINION) {
                <div class="agpr-curatedAutoInsightDialog-extraSpacing">
                    <div class="agpr-mentionWorkbenchDialog-insights-main-promptKeywords">
                        <agpr-radio
                            [id]="id + '_insight_savedMentionKeywordContextRadio'"
                            label="Mention.workbench.insights.prompt.savedKeywords"
                            hiddenLabel="Mention.workbench.insights.prompt.savedKeywords"
                            [(ngModel)]="isMentionKeywords"
                            [value]="true"
                        ></agpr-radio>
                        <agpr-radio
                            [id]="id + '_insight_manualKeywordsRadio'"
                            label="Mention.workbench.insights.prompt.manualKeywords"
                            hiddenLabel="Mention.workbench.insights.prompt.manualKeywords"
                            [(ngModel)]="isMentionKeywords"
                            [value]="false"
                        ></agpr-radio>
                        @if (!isMentionKeywords) {
                            <div class="agpr-curatedAutoInsightDialog-indent">
                                <agpr-text-input-chips
                                    [id]="id + '_insight_manualKeywords'"
                                    [placeholder]="'Mention.workbench.insights.prompt.enterKeywords'"
                                    [(ngModel)]="manualKeywords"
                                ></agpr-text-input-chips>
                            </div>
                        }
                    </div>
                </div>
            }

            @if (selectedMentionInsightType?.value !== mentionInsightTypes.QUOTES && selectedMentionInsightType?.value !== mentionInsightTypes.CUSTOM) {
                <div class="agpr-curatedAutoInsightDialog-extraSpacing">
                    <agpr-dropdown
                        label="Common.dialog.aiHelper.language"
                        [options]="promptLanguageOptions"
                        [(ngModel)]="selectedPromptLanguageOption"
                        [infoCircleTooltip]="'Common.dialog.aiHelper.languageTooltip'"
                    ></agpr-dropdown>
                </div>
            }

            @if (selectedMentionInsightType?.value === mentionInsightTypes.CUSTOM) {
                <div class="agpr-curatedAutoInsightDialog-spacing">
                    <agpr-dropdown
                        label="Briefings.analysis.customAnalysisType"
                        [placeholder]="'Briefings.analysis.customAnalysisType.placeholder'"
                        [options]="customInsightsOptions"
                        [(ngModel)]="selectedCustomInsightOption"
                        (ngModelChange)="selectCustomInsightOption()"
                    ></agpr-dropdown>
                </div>

                @if (selectedCustomInsightOption) {
                    @if (!selectedCustomInsightOption?.value?.id) {
                        <agpr-form-message>
                            {{ 'Briefings.analysis.errors.customPromptIsRequired' | localize }}
                        </agpr-form-message>
                    }

                    <div class="agpr-curatedAutoInsightDialog-padding">
                        <agpr-text-input
                            [id]="id + '_custom_name'"
                            [maxLength]="64"
                            [label]="'Mention.workbench.insights.prompt.custom.name'"
                            [placeholder]="'Mention.workbench.insights.prompt.custom.name.placeholder'"
                            [required]="true"
                            [(ngModel)]="selectedCustomInsightOption.value.name"
                            (ngModelChange)="customInsightFieldChanged()"
                        ></agpr-text-input>
                    </div>
                    <div class="agpr-curatedAutoInsightDialog-padding">
                        <agpr-textarea-input
                            [id]="id + '_custom_prompt'"
                            [label]="'Mention.workbench.insights.prompt.custom.prompt'"
                            [required]="true"
                            [placeholder]="'Mention.workbench.insights.prompt.custom.prompt.tooltip'"
                            [tooltip]="'Mention.workbench.insights.prompt.custom.prompt.tooltip'"
                            ariaLabel="Mention.workbench.insights.prompt.custom.prompt.tooltip"
                            [(ngModel)]="selectedCustomInsightOption.value.prompt"
                            [rows]="7"
                            [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                            (ngModelChange)="customInsightFieldChanged()"
                        ></agpr-textarea-input>
                    </div>
                    <div class="agpr-curatedAutoInsightDialog-customActions">
                        <div class="agpr-curatedAutoInsightDialog-spacer"></div>
                        <agpr-button
                            [id]="id + '_insight_saveCustomInsight'"
                            label="Briefings.analysis.customAnalysis.save"
                            [style]="buttonTypes.tertiary"
                            [disabled]="!allowCustomInsightSave"
                            [agprTooltip]="saveCustomInsightTooltip"
                            (click)="saveCustomInsight()"
                        ></agpr-button>
                        @if (selectedCustomInsightOption.value?.id) {
                            <agpr-button
                                [style]="buttonTypes.tertiary"
                                [disabled]="!allowCustomInsightSave"
                                label="Briefings.analysis.customAnalysis.saveAs"
                                [agprTooltip]="'Briefings.analysis.customAnalysis.saveAs.tooltip'"
                                [id]="id + '_insight_saveAsCustomInsight'"
                                (click)="saveAsCustomInsight()"
                            ></agpr-button>
                        }
                    </div>
                }
            }

            <agpr-checkbox
                [id]="id + '_curatedAutoInsightDialog_setAsPreferred'"
                label="Briefings.blockType.autoGeninsights.setAsPreferred"
                [binary]="true"
                [(ngModel)]="setPreferred"
            ></agpr-checkbox>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id+'_cancelButton'"
            (click)="close()"
            [label]="'Core.button.cancel'"
            [style]="buttonTypes.secondary"
        ></agpr-button>
        <agpr-button
            [id]="id + '_applyButton'"
            (click)="apply()"
            [label]="'Mention.workbench.insights.generateInsight'"
            [tooltip]="generateButtonTooltip"
            [disabled]="numMentions === 0 || (selectedMentionInsightType?.value === mentionInsightTypes.CUSTOM && (allowCustomInsightSave || !selectedCustomInsightOption?.value?.id))"
            [style]="buttonTypes.primary"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
